import { Tray, YieldBearingAssetRiskAssessmentSection } from '@/components';
import { TrayScreen } from '@/components/atoms/Tray/interfaces/Tray';
import { TrayNavigationProvider } from '@/components/providers/common/TrayNavigationProvider';
import { YieldBearingAssetInterface } from '@/interfaces';
import { FC, useCallback, useMemo, useState } from 'react';
interface QuestionAnswer {
  question: string;
  rating: number;
}
interface YieldBearingAssetCompositionRecommendationTrayProps {
  isOpen: boolean;
  onClose: () => void;
  asset: YieldBearingAssetInterface;
  onOptimize: (qaList: QuestionAnswer[], userCommentary?: string) => void;
}
const YieldBearingAssetCompositionRecommendationTrayContent: FC<
  YieldBearingAssetCompositionRecommendationTrayProps
> = ({ isOpen, onClose, asset, onOptimize }) => {
  const [qaList, setQaList] = useState<QuestionAnswer[]>([]);
  const [userCommentary, setUserCommentary] = useState<string>('');
  const handleAssessmentChange = (
    updatedQaList: QuestionAnswer[],
    updatedUserCommentary?: string,
  ) => {
    setQaList(updatedQaList);
    if (updatedUserCommentary !== undefined) {
      setUserCommentary(updatedUserCommentary);
    }
  };
  const handleOptimizeClick = useCallback(() => {
    onOptimize(qaList, userCommentary);
  }, [qaList, userCommentary, onOptimize]);
  const screens: TrayScreen[] = useMemo(
    () => [
      {
        headerNode: 'Recommendation',
        content: (
          <YieldBearingAssetRiskAssessmentSection
            onAssessmentChange={handleAssessmentChange}
          />
        ),
        extraButton1Label: 'Optimize',
        extraButton1OnClick: handleOptimizeClick,
        extraButton1Icon: 'ai',
        extraButton1Props: {
          intent: 'ai',
          iconStyles: { intent: 'ai', size: 'md' },
        },
      },
    ],
    [asset.ticker, handleOptimizeClick],
  );
  return (
    <Tray
      isOpen={isOpen}
      onClose={onClose}
      screens={screens}
      className="overflow-hidden"
    />
  );
};
const YieldBearingAssetCompositionRecommendationTray: FC<
  YieldBearingAssetCompositionRecommendationTrayProps
> = (props) => (
  <TrayNavigationProvider>
    <YieldBearingAssetCompositionRecommendationTrayContent {...props} />
  </TrayNavigationProvider>
);
export default YieldBearingAssetCompositionRecommendationTray;
